import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sports-marquee',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sports-marquee.component.html',
  styleUrl: './sports-marquee.component.scss',
})
export class SportsMarqueeComponent {
  sports: string[] = [
    'WATER RAFTING',
    'SKYDIVING',
    'RAFTING',
    'JUMPING',
    'BMX',
    'MOTOCROSS',
    'SURFING',
  ];
  logoUrl = 'assets/images/home/scrollerLogo.png';
}
